
import {ToolHistory}	from "../classes/ToolHistory";
import vindrApi		from "../utils/vindrapi";

class log {

	constructor(tc){
		this.tc  = tc;
		this.map = tc.map;
	}

	getHistory(){
		const aux = new ToolHistory(this.tc, true);
		return aux.getHistory().then(()=>{
			this.updateToolbar();
		});
	}

	// ─── helpers ─────────────────────────────────────────────────────────────

	_parse(geom){
		if(!geom) return null;
		return typeof geom === 'string' ? JSON.parse(geom) : geom;
	}

	_redraw(layerIds, withCircles = false){
		if(this.tc.infoLayers?.current){
			layerIds.forEach(id => this.tc.infoLayers.current.resetSystemLayer(id));
		}
		if(withCircles){
			this.tc.draw.drawCircles(this.tc.scenario);
		}
		this.tc.setState(this.tc.scenario);
		if(this.tc.handler?.display) this.tc.handler.display();
	}

	// ─── per-entity apply ─────────────────────────────────────────────────────

	_applyTurbine(entityId, state){
		const wtgs = this.tc.scenario.wtgs;
		if(!state){
			const idx = wtgs.findIndex(t => t.turbineid == entityId);
			if(idx > -1) wtgs.splice(idx, 1);
		} else {
			const t = { turbineid: state.turbine_id, name: state.name, geometry: this._parse(state.geometry) };
			const idx = wtgs.findIndex(w => w.turbineid == entityId);
			if(idx > -1) Object.assign(wtgs[idx], t);
			else wtgs.push(t);
		}
		this._redraw(['turbines', 'ellipses'], true);
	}

	_applyNsa(entityId, state){
		const nsas = this.tc.scenario.nsas;
		if(!state){
			const idx = nsas.findIndex(s => s.nsaid == entityId);
			if(idx > -1) nsas.splice(idx, 1);
		} else {
			const s = { nsaid: state.nsa_id, name: state.name, geometry: this._parse(state.geometry) };
			const idx = nsas.findIndex(n => n.nsaid == entityId);
			if(idx > -1) Object.assign(nsas[idx], s);
			else nsas.push(s);
		}
		this._redraw(['sensors']);
	}

	_applyBoundary(state){
		if(state?.geometry){
			if(!this.tc.scenario.boundary) this.tc.scenario.boundary = {};
			this.tc.scenario.boundary.geometry = this._parse(state.geometry);
		}
		this._redraw(['boundary']);
	}

	_applyRoad(entityId, state){
		const roads = this.tc.scenario.roads;
		if(!state){
			const idx = roads.findIndex(r => r.roadid == entityId);
			if(idx > -1) roads.splice(idx, 1);
		} else {
			const r = { roadid: state.road_id, name: state.name, width: state.width, color: state.color, geometry: this._parse(state.geometry) };
			const idx = roads.findIndex(r2 => r2.roadid == entityId);
			if(idx > -1) Object.assign(roads[idx], r);
			else roads.push(r);
		}
		this._redraw(['roads']);
	}

	_applyPower(entityId, state){
		const powerlines = this.tc.scenario.powerlines;
		if(!state){
			const idx = powerlines.findIndex(p => p.powerlineid == entityId);
			if(idx > -1) powerlines.splice(idx, 1);
		} else {
			const p = { powerlineid: state.power_id, name: state.name, width: state.width, color: state.color, geometry: this._parse(state.geometry) };
			const idx = powerlines.findIndex(p2 => p2.powerlineid == entityId);
			if(idx > -1) Object.assign(powerlines[idx], p);
			else powerlines.push(p);
		}
		this._redraw(['powerlines']);
	}

	_applyAnnotation(entityId, state){
		const annotations = this.tc.scenario.annotations;
		if(!state){
			const idx = annotations.findIndex(a => a.id == entityId);
			if(idx > -1) annotations.splice(idx, 1);
		} else {
			const idx = annotations.findIndex(a => a.id == entityId);
			if(idx > -1) Object.assign(annotations[idx], state);
			else annotations.push({...state});
		}
		this._redraw(['annotations']);
	}

	_applyCircle(entityId, state){
		const circles = this.tc.scenario.wtgSettings.circles;
		if(!state){
			const idx = circles.findIndex(c => c.id == entityId);
			if(idx > -1) circles.splice(idx, 1);
		} else {
			const idx = circles.findIndex(c => c.id == entityId);
			if(idx > -1) Object.assign(circles[idx], state);
			else circles.push({...state});
		}
		this.tc.setState(this.tc.scenario);
		this.tc.draw.drawCircles(this.tc.scenario);
		if(this.tc.handler?.display) this.tc.handler.display();
	}

	_applyEllipse(state){
		if(state){
			const custom = this.tc.scenario.wtgSettings?.windEllipse?.custom;
			if(custom){
				custom.orientation = state.turbine_ellipse_direction;
				custom.majorAxis   = state.turbine_ellipse_major_axis;
				custom.minorAxis   = state.turbine_ellipse_minor_axis;
			}
		}
		this._redraw(['ellipses']);
	}

	_applyWtgSettings(state){
		var reloadHeights = false;
		if(state){
			
			if(this.tc.scenario.wtgSettings.turbineType != state.turbine_type && this.tc?.handler?.type == "turbine")
				reloadHeights = true;
			
			this.tc.scenario.wtgSettings.turbineType = state.turbine_type;
			this.tc.scenario.wtgSettings.hubHeight   = state.hub_height;
			
			
		}
		const tasks = [reloadHeights ? this.tc.handler.getHeights(state.turbine_type): true];
		
		Promise.all(tasks).then(()=>{
			this._redraw(['turbines', 'ellipses']);
		});
		
	}

	_applyState(event, isUndo){
		const state = isUndo ? event.old_state : event.new_state;
		switch(event.entity_type){
			case 'turbine':        this._applyTurbine(event.entity_id, state);  break;
			case 'nsa':            this._applyNsa(event.entity_id, state);       break;
			case 'boundary':       this._applyBoundary(state);                   break;
			case 'road':           this._applyRoad(event.entity_id, state);      break;
			case 'power':          this._applyPower(event.entity_id, state);     break;
			case 'annotation':     this._applyAnnotation(event.entity_id, state);break;
			case 'turbine_circle': this._applyCircle(event.entity_id, state);    break;
			case 'ellipse':        this._applyEllipse(state);                    break;
			case 'wtg_settings':   this._applyWtgSettings(state);               break;
		}
	}

	// ─── history navigation ───────────────────────────────────────────────────

	_getUndoCandidate(){
		const history = ToolHistory.history;
		if(!Array.isArray(history)) return null;
		return history.find(e => e.type === 'change' && !e.undone) ?? null;
	}

	_getRedoCandidate(){
		const history = ToolHistory.history;
		if(!Array.isArray(history)) return null;
		const undone = history.filter(e => e.type === 'change' && e.undone);
		return undone.length ? undone[undone.length - 1] : null;
	}

	async back(){
		if(!Array.isArray(ToolHistory.history))
			await this.getHistory();

		const nonUndone = (ToolHistory.history ?? []).filter(e => e.type === 'change' && !e.undone);
		const candidate = nonUndone[0] ?? null;
		if(!candidate) return false;

		// target = the version we land on = the action just before the one we're undoing
		const targetId = nonUndone[1]?.id ?? 0;

		this._applyState(candidate, true);
		candidate.undone = true;
		this.updateToolbar();

		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;
		vindrApi.undoChange(pId, sId, targetId).then((res)=>{
			
			if(this.tc){
				this.tc.checkOutdated(res);
			}
			
		}).catch(()=>{});

		return true;
	}

	async forward(){
		if(!Array.isArray(ToolHistory.history))
			await this.getHistory();

		const candidate = this._getRedoCandidate();
		if(!candidate) return false;

		this._applyState(candidate, false);
		candidate.undone = false;
		this.updateToolbar();

		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;
		vindrApi.redoChange(pId, sId, candidate.id).then((res)=>{
			
			if(this.tc){
				this.tc.checkOutdated(res);
			}
			
		}).catch(()=>{});

		return true;
	}

	// ─── toolbar ──────────────────────────────────────────────────────────────

	updateToolbar(){
		const history = ToolHistory.history;
		if(!Array.isArray(history)){
			this.map.controlBar.disable(['undo', 'redo']);
			return;
		}
		const canUndo = history.some(e => e.type === 'change' && !e.undone);
		const canRedo = history.some(e => e.type === 'change' && e.undone);
		canUndo ? this.map.controlBar.enable('undo')  : this.map.controlBar.disable('undo');
		canRedo ? this.map.controlBar.enable('redo')  : this.map.controlBar.disable('redo');
	}
}

export default log;
